import { render, staticRenderFns } from "./html.vue?vue&type=template&id=5cc4dc2c&scoped=true"
import script from "./html.vue?vue&type=script&lang=ts"
export * from "./html.vue?vue&type=script&lang=ts"
import style0 from "./html.vue?vue&type=style&index=0&id=5cc4dc2c&prod&scoped=true&lang=css"
import style1 from "./html.vue?vue&type=style&index=1&id=5cc4dc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4dc2c",
  null
  
)

export default component.exports